import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useApp } from '../context/AppContext';
import { useNotification } from '../context/NotificationContext';
import { auth } from '../services/firebase';
import Logo from './Logo';
import Haptics from '../utils/haptics';

const Header = () => {
  const { t } = useTranslation();
  const { isOnline, isLoadingRates, refreshRates, requestConfirmation, closeConfirmation, logout, isAuthenticated } = useApp();
  const { addNotification } = useNotification();
  const navigate = useNavigate();
  const location = useLocation();

  const showHeader = !['/login', '/signup'].includes(location.pathname);

  if (!showHeader) {
    return (
      <header className="bg-gray-800 text-white p-4 text-center">
        <h1 className="text-2xl font-bold">{t('app_name')}</h1>
      </header>
    );
  }

  const handleManualRefresh = async () => {
    if (isLoadingRates || !isOnline) return;
    Haptics.tap();
    try {
      await refreshRates();
      addNotification(t('data_resynced'), 'success');
    } catch (e) {
      addNotification(t('sync_failed'), 'error');
    }
  };

  const handleQuickLogout = () => {
    Haptics.tap();
    requestConfirmation({
      title: t('log_out') + '?',
      message: t('confirm_logout'),
      confirmText: t('log_out'),
      cancelText: t('cancel'),
      onConfirm: async () => {
        await logout();
        closeConfirmation();
        navigate('/login');
      }
    });
  };

  return (
    <header className="bg-white dark:bg-gray-800 shadow-md p-4 flex justify-between items-center sticky top-0 z-40">
      <div className="flex items-center">
        <Logo />
      </div>
      <div className="flex items-center space-x-2 sm:space-x-4">
        {isOnline ? (
          <button onClick={handleManualRefresh} className={`p-2 rounded-full text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 ${isLoadingRates ? 'animate-spin' : ''}`}>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h5M20 20v-5h-5M4 4l16 16" /></svg>
          </button>
        ) : (
          <div className="p-2 rounded-full bg-yellow-500 text-white">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636a9 9 0 010 12.728M12 18.364a9 9 0 000-12.728m-6.364 0a9 9 0 010 12.728M12 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
          </div>
        )}
        {isAuthenticated && (
          <button onClick={handleQuickLogout} className="p-2 rounded-full text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;